import React from 'react';
import { connect } from 'react-redux';
const NavBar = (props) => {
  const { themeSettingsData } = props;
  const normalStyle = { backgroundColor: 'white', color: 'black' };
  const isSmallScreen = window.matchMedia('(max-width: 768px)').matches;
  return (
    <div className="mb-4">
      <div
        className="nav-header"
        style={{
          height: isSmallScreen
            ? themeSettingsData?.P_THEME?.P_HEADER_LOGO_HEIGHT_MOBILE === 'auto'
              ? `${themeSettingsData?.P_THEME?.P_HEADER_LOGO_HEIGHT_MOBILE}`
              : `${themeSettingsData?.P_THEME?.P_HEADER_LOGO_HEIGHT_MOBILE * 2}px`
            : themeSettingsData?.P_THEME?.P_HEADER_LOGO_HEIGHT === 'auto'
            ? `${themeSettingsData?.P_THEME?.P_HEADER_LOGO_HEIGHT}`
            : `${themeSettingsData?.P_THEME?.P_HEADER_LOGO_HEIGHT * 2}px`,
          backgroundColor: themeSettingsData?.P_THEME?.P_HEADER_BG_COLOR,
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <div className="nav-header-container container-xxl">
          {themeSettingsData?.P_THEME?.P_HEADER_LOGO || themeSettingsData?.P_THEME?.P_HEADER_LOGO_MOBILE ? (
            <div>
              <div className="rounded-0 border-0 p-0 bg-transparent">
                <img
                  className="nav-logo"
                  src={isSmallScreen ? themeSettingsData?.P_THEME?.P_HEADER_LOGO_MOBILE : themeSettingsData?.P_THEME?.P_HEADER_LOGO}
                  alt="navLogo"
                  style={{
                    height: isSmallScreen
                      ? themeSettingsData?.P_THEME?.P_HEADER_LOGO_HEIGHT_MOBILE === 'auto'
                        ? `${themeSettingsData?.P_THEME?.P_HEADER_LOGO_HEIGHT_MOBILE}`
                        : `${themeSettingsData?.P_THEME?.P_HEADER_LOGO_HEIGHT_MOBILE}px`
                      : themeSettingsData?.P_THEME?.P_HEADER_LOGO_HEIGHT === 'auto'
                      ? `${themeSettingsData?.P_THEME?.P_HEADER_LOGO_HEIGHT}`
                      : `${themeSettingsData?.P_THEME?.P_HEADER_LOGO_HEIGHT}px`,
                    width: isSmallScreen
                      ? themeSettingsData?.P_THEME?.P_HEADER_LOGO_WIDTH_MOBILE === 'auto'
                        ? `${themeSettingsData?.P_THEME?.P_HEADER_LOGO_WIDTH_MOBILE}`
                        : `${themeSettingsData?.P_THEME?.P_HEADER_LOGO_WIDTH_MOBILE}px`
                      : themeSettingsData?.P_THEME?.P_HEADER_LOGO_WIDTH === 'auto'
                      ? `${themeSettingsData?.P_THEME?.P_HEADER_LOGO_WIDTH}`
                      : `${themeSettingsData?.P_THEME?.P_HEADER_LOGO_WIDTH}px`,
                  }}
                />
              </div>
            </div>
          ) : (
            ''
          )}
        </div>
      </div>
      <div style={normalStyle}>
        <div className="container-xxl">
          <div style={{ height: '15px', backgroundColor: themeSettingsData?.P_THEME?.P_SEP_REG_BG_COLOR, width: '100%' }}></div>
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = ({ themeSlice }) => {
  const { themeSettingsData } = themeSlice;
  return { themeSettingsData };
};

const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(NavBar);
